<div class="detail-order" *ngIf="order">
    <div class="order-page-header">
        <div class="order-breadcrumb">
            <h1 class="title-detail-order m-0">Pedidos</h1>
            <mat-divider [vertical]="true" class="breadcrumb-divider"></mat-divider>
            <!-- El id interno de la web no le dice nada a nadie: se enseña el de la
                 transacción del TPV, que es el número con el que Redsys identifica
                 el cobro. Los pedidos de abonado no tienen, y ahí cae al id. -->
            <h1 class="title-detail-order m-0">{{order.id_invoicing || order.id}}</h1>
        </div>
        <mat-divider class="divider-title"></mat-divider>
    </div>
    <div class="btn-back-detail" (click)="goBack()">
        <i class="fal fa-arrow-left"></i>
        <span>Ver todos los pedidos</span>
    </div>
    <div class="info-order">
        <div class="card-white-panel">
            <div class="d-flex justify-content-between align-items-center padding-25 margin-20 flex-wrap">
                <div class="title-detail">
                    <h2 class="m-0"><span>Detalle</span>
                        <mat-divider [vertical]="true" *ngIf="order.invoice_number"></mat-divider>
                        <span>{{order.invoice_number}}</span>
                        <span class="ticket-pill pill-abonado header-pill" *ngIf="isSeasonPassOrder">
                            <i class="fa-light fa-id-card"></i> Pedido de abonado
                        </span>
                    </h2>
                </div>
                <div class="btns-tickets">
                    <div class="btn-create btn-create-border m-0 desktop-refund-btn" (click)="refundOrder()"
                        *ngIf="(order.status?.short_name == 'paid' || order.status?.short_name == 'partial_refund') && canRefundOrder()">
                        <i class="fal fa-arrow-rotate-left"></i>
                        <p class="m-0">Devolver pedido</p>
                    </div>
                    <div class="btn-create m-0"
                        *ngIf="(order.status?.short_name == 'paid' || order.status?.short_name == 'refund') && !isSeasonPassOrder"
                        (click)="openPrintA4()">
                        <i class="fal fa-print"></i>
                        <p class="m-0">Imprimir entradas</p>
                    </div>
                    <div class="btn-create m-0"
                        *ngIf="(order.status?.short_name == 'paid' || order.status?.short_name == 'refund') && !isSeasonPassOrder"
                        (click)="openPrintTicket()">
                        <i class="fal fa-ticket"></i>
                        <p class="m-0">Imprimir ticket</p>
                    </div>
                    <div class="mobile-menu-btn" *ngIf="(order.status?.short_name == 'paid' || order.status?.short_name == 'partial_refund') && canRefundOrder()">
                        <div [matMenuTriggerFor]="mobileMenu" class="d-flex pointer-in m-0">
                            <i class="icon-option fal fa-ellipsis-vertical"></i>
                        </div>
                        <mat-menu class="options-menu-control-panel" #mobileMenu="matMenu" xPosition="before">
                            <button mat-menu-item (click)="refundOrder()">
                                <i class="fal fa-arrow-rotate-left" style="margin-right: 8px;"></i>
                                <span>Devolver pedido</span>
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </div>
            <mat-divider></mat-divider>
            <!-- Información general -->
            <div class="general-info-ticket">
                <div class="item-general-info">
                    <p class="title-item-general">ID del pedido</p>
                    <p class="text-item-general">{{order.invoice_number || '-'}}</p>
                </div>
                <div class="item-general-info" *ngIf="order.id_invoicing">
                    <p class="title-item-general">ID de transacción</p>
                    <p class="text-item-general">{{order.id_invoicing}}</p>
                </div>
                <div class="item-general-info">
                    <p class="title-item-general">Nombre y apellidos</p>
                    <p class="text-item-general">{{order.cart.user.name || '-'}}</p>
                </div>
                <div class="item-general-info">
                    <p class="title-item-general">Correo electrónico</p>
                    <p class="text-item-general">{{order.cart.user.email || '-'}}</p>
                </div>
                <div class="item-general-info">
                    <p class="title-item-general">Canal</p>
                    <!-- Estos pedidos no vienen de una venta: los genera la publicación
                         del evento, así que no tienen canal. -->
                    <p class="text-item-general">{{isSeasonPassOrder ? 'Abono de temporada' : (channelName || '-')}}</p>
                </div>
                <div class="item-general-info">
                    <p class="title-item-general">Precio total del pedido</p>
                    <p class="text-item-general">{{(order.total_order?.total ?? order?.total) | number:'1.2-2'}}€</p>
                </div>
                <div class="item-general-info">
                    <p class="title-item-general">Fecha y hora trans.</p>
                    <p class="text-item-general">{{order.created_at | date:'dd/MM/yyyy HH:mm'}}h</p>
                </div>
                <div class="item-general-info" *ngIf="!isSeasonPassOrder">
                    <p class="title-item-general">Número de teléfono</p>
                    <!-- El número al que se enviaron las entradas, no el del
                         comprador: solo tiene valor si hubo envío por WhatsApp. -->
                    <p class="text-item-general">{{formatPhone(order.phone)}}</p>
                </div>
                <div class="item-general-info" *ngIf="isSeasonPassOrder">
                    <p class="title-item-general">Nº de abonado</p>
                    <p class="text-item-general">
                        <span>{{seasonPass?.member_number || '-'}}</span>
                        <span class="link-season-pass" *ngIf="seasonPass?.id" (click)="goToSeasonPass()">Ver abono</span>
                    </p>
                </div>
                <div class="item-general-info">
                    <p class="title-item-general">Estado</p>
                    <p class="text-item-general">{{order.status.name}}</p>
                </div>
                <!-- Datos del abono: solo si la API los trae (una baja lo borra en
                     soft delete y la relación se queda vacía). -->
                <ng-container *ngIf="isSeasonPassOrder && seasonPass">
                    <div class="item-general-info">
                        <p class="title-item-general">Temporada</p>
                        <p class="text-item-general">{{seasonPass?.season?.name || '-'}}</p>
                    </div>
                    <div class="item-general-info">
                        <p class="title-item-general">Tipo de abono</p>
                        <p class="text-item-general">{{seasonPass?.category?.name || '-'}}</p>
                    </div>
                    <div class="item-general-info">
                        <p class="title-item-general">Estado del abono</p>
                        <p class="text-item-general">{{seasonPass?.status?.name || '-'}}</p>
                    </div>
                </ng-container>
            </div>
        </div>
        <!-- Entradas por evento -->
        <div class="grid-tickets">
            <ng-container *ngFor="let group of seats | groupByEvent">
                <div class="card-white-panel card-event">
                    <div class="info-event-pay p-3">
                        <div class="img-event">
                            <img [src]="urlEventImage+group.event.image_url" [alt]="group.event.title" />
                        </div>
                        <div class="basic-info-event">
                            <p class="title-event m-0" [innerHTML]="group.event.title"></p>
                            <div class="m-0 grey-info-event d-flex">
                                <span>{{group.eventDate | date: 'dd/MM/yyyy':'+0000' }}</span>
                                <mat-divider style="margin: 0px 0.5rem;" [vertical]="true"></mat-divider>
                                <span class="hour-event">
                                    {{group.eventDate | date:'HH:mm':'+0000' }}h</span>
                            </div>
                            <p class="m-0 grey-info-event"><span *ngIf="group.event.space">{{group.event.space.name}} -
                                </span>{{(group.event.space ? group.event.space.address : group.event.address) || ' '}}</p>
                            <p class="m-0 grey-info-event">{{group.event.company?.name}}</p>
                        </div>
                    </div>
                    <div class="info-seats">
                        <ng-container *ngFor="let line of group.lines">
                            <div *ngFor="let booking of line.bookings">
                                <mat-divider></mat-divider>
                                <div class="info-ticket" [class.refund-ticket]="booking.status?.name == 'refunded'">
                                    <div class="d-flex align-items-center gap-3">
                                        <div [matMenuTriggerFor]="ticketOptions" class="d-flex pointer-in m-0"
                                            *ngIf="booking.status?.name == 'confirmed' && !isSeasonPassBooking(booking)">
                                            <i class="icon-option fal fa-ellipsis-vertical"></i>
                                        </div>
                                        <mat-menu class="options-menu-control-panel" #ticketOptions="matMenu">
                                            <button mat-menu-item (click)="printSingleA4Ticket(booking)">Imprimir
                                                entrada</button>
                                            <button mat-menu-item (click)="printSigleTicket(booking)">Imprimir ticket</button>
                                            <button mat-menu-item (click)="refundTicket(booking)"
                                                *ngIf="canRefundOrder()">Devolución parcial</button>
                                        </mat-menu>
                                        <div class="refund-info" *ngIf="booking.status?.name == 'refunded'">
                                            <p class="m-0 ticket-type refund-text">Devuelto</p>
                                            <p class="m-0 grey-info-event refund-date">{{booking.created_at | date:'dd/MM/yyyy HH:mm'}}</p>
                                        </div>
                                        <div class="ticket-main">
                                            <div class="d-flex align-items-center gap-2 flex-wrap">
                                                <p class="m-0 ticket-type">{{getTicketName(line, booking)}}</p>
                                                <span class="ticket-pill pill-abonado" *ngIf="isSeasonPassBooking(booking)">
                                                    <i class="fa-light fa-id-card"></i> {{getSeasonPassLabel(booking)}}
                                                </span>
                                                <span class="ticket-pill pill-abono" *ngIf="line.ticket?.idbond || abonoLineIds.has(line.id)">
                                                    <i class="fa-light fa-ticket"></i> Abono
                                                </span>
                                                <span class="ticket-pill pill-descuento" *ngIf="realDiscountLineIds.has(line.id)">
                                                    <i class="fa-light fa-tag"></i> Descuento
                                                </span>
                                            </div>
                                            <div class="d-flex grey-info-event info-position" *ngIf="booking.seat">
                                                <span>Zona: {{booking.seat.map_section?.name}}{{ booking.seat.map_section?.show_row !== false || booking.seat.map_section?.show_seat_label !== false ? ',' : '' }}</span>
                                                <span *ngIf="booking.seat.map_section?.show_row !== false">Fila: {{booking.seat.row}}{{ booking.seat.map_section?.show_seat_label !== false ? ',' : '' }}</span>
                                                <span><ng-container *ngIf="booking.seat.map_section?.show_seat_label !== false">Asiento: </ng-container>{{booking.seat.seat}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="price-ticket">
                                        <p class="m-0 included-in-pass" *ngIf="isSeasonPassBooking(booking)">Incluido en el abono</p>
                                        <ng-container *ngIf="!isSeasonPassBooking(booking)">
                                            <span *ngIf="line.discount_total > 0" class="price-original-strikethrough">
                                                {{getBookingOriginalUnitPrice(line) | number:'1.2-2'}}€
                                            </span>
                                            <p class="m-0 grey-info-event" [class.price-discounted]="line.discount_total > 0">
                                                {{getBookingUnitPrice(line) | number:'1.2-2'}}€
                                            </p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
        <!-- Subtotales y total -->
        <div class="footer-order">

            <!-- Subtotal sin descuento -->
            <div class="d-flex justify-content-end line-footer-order" *ngIf="order.total_order">
                <p class="title-fee">Subtotal</p>
                <p class="number-fees">{{order.total_order.subtotal_without_discount | number:'1.2-2'}}€</p>
            </div>

            <!-- Descuentos (desplegable) -->
            <div class="d-flex justify-content-end line-footer-order discount-toggle-row"
                 *ngIf="order.total_order?.discount_total > 0"
                 (click)="showDiscountDetail = !showDiscountDetail">
                <p class="title-fee discount-label">
                    <i class="fa-light fa-tag"></i> Descuentos
                    <i class="fa-light" [class.fa-chevron-down]="!showDiscountDetail" [class.fa-chevron-up]="showDiscountDetail"></i>
                </p>
                <p class="number-fees discount-amount">-{{order.total_order.discount_total | number:'1.2-2'}}€</p>
            </div>
            <div class="discount-detail-list" *ngIf="showDiscountDetail && discountLines.length > 0">
                <div class="discount-detail-item" *ngFor="let disc of discountLines">
                    <span class="discount-detail-name"><i class="fa-light fa-minus"></i> {{disc.name}}</span>
                    <span class="discount-detail-amount">-{{disc.total | number:'1.2-2'}}€</span>
                </div>
            </div>

            <!-- Gastos de gestión (solo si > 0) -->
            <div class="d-flex justify-content-end line-footer-order" *ngIf="(order.total_order?.fee_total ?? order.total_fee ?? fees) > 0">
                <p class="title-fee">Gastos de gestión</p>
                <p class="number-fees">{{(order.total_order?.fee_total ?? order.total_fee ?? fees) | number:'1.2-2'}}€</p>
            </div>

            <mat-divider></mat-divider>

            <!-- Devolución (si aplica) -->
            <div class="d-flex justify-content-end line-footer-order"
                *ngIf="order.total_order?.refund_total > 0">
                <p class="title-fee">Devolución</p>
                <p class="number-fees">-{{order.total_order.refund_total | number:'1.2-2'}}€</p>
            </div>
            <mat-divider *ngIf="order.total_order?.refund_total > 0"></mat-divider>

            <!-- Total final -->
            <div class="d-flex justify-content-end line-footer-order">
                <p class="total-order">Total</p>
                <p class="number-total">{{(order.total_order?.total ?? order?.total) | number:'1.2-2'}}€</p>
            </div>
        </div>
    </div>
</div>
